import { useTranslation } from 'react-i18next';
import { saveLanguage } from '@sheshdash/shared';

const languages = [
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'ru', label: 'RU', flag: '🇷🇺' },
  { code: 'de', label: 'DE', flag: '🇩🇪' },
  { code: 'es', label: 'ES', flag: '🇪🇸' },
  { code: 'fr', label: 'FR', flag: '🇫🇷' },
  { code: 'it', label: 'IT', flag: '🇮🇹' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'ja', label: '日本語', flag: '🇯🇵' },
  { code: 'ko', label: '한국어', flag: '🇰🇷' },
];

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    saveLanguage(lng);
  };

  return (
    <div style={styles.container}>
      {languages.map(lang => (
        <button
          key={lang.code}
          data-testid={`spa-language-${lang.code}`}
          onClick={() => changeLanguage(lang.code)}
          style={{
            ...styles.button,
            ...(i18n.language === lang.code ? styles.active : {})
          }}
          title={lang.label}
        >
          {lang.flag}
        </button>
      ))}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    gap: '8px',
  },
  button: {
    padding: '6px 12px',
    fontSize: '14px',
    fontWeight: 'bold',
    backgroundColor: 'var(--surface-subtle)',
    color: 'var(--text-secondary)',
    border: '2px solid var(--border-default)',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  active: {
    backgroundColor: 'var(--color-primary)',
    color: 'var(--text-on-primary)',
    borderColor: 'var(--color-primary)',
  },
};
